<template>
  <div>
    <modal name="editCampo" height="auto" width="1200" :scrollable="true" :clickToClose="false">
      <CamposDisponiveis
          :campos="tipo.de"
          nome="camposDisponiveisDe"
          :onSelect="alterarCampoDe"
      />
      <CamposDisponiveis
          :campos="tipo.para"
          nome="camposDisponiveisPara"
          :onSelect="alterarCampoPara"
      />
      <CloseModal :close="close"/>

      <div class="modalbox">
        <div class="modalbox-content">
          <div class="modal-header-info" v-if="vista === 'lista'">
            <div class="header-title">{{ tipo.titulo }}</div>
            <div class="header-desc">
              Chave: <code>{{ tipo.chave }}</code> · {{ campos.length }} mapeamento(s)
            </div>
          </div>

          <!-- VISTA: LISTA -->
          <template v-if="vista === 'lista'">
            <div v-if="campos.length === 0" class="empty-state">
              <div class="empty-icon"><fa-icon icon="cubes" /></div>
              <div class="empty-text">Nenhum mapeamento cadastrado</div>
              <div class="empty-desc">Clique no botão abaixo para criar o primeiro mapeamento.</div>
            </div>

            <div
              v-for="(campo, idx) in campos"
              :key="idx"
              class="lista-card"
              :class="{ 'lista-card--invalid': !isCampoValido(campo) }"
              @click="abrirEditor(idx)"
            >
              <span class="lista-ordem">#{{ idx + 1 }}</span>
              <span class="lista-tipo-badge" :class="badgeClass(campo)">
                <fa-icon :icon="badgeIcone(campo)" /> {{ badgeLabel(campo) }}
              </span>
              <span class="lista-resumo">{{ resumoLinha(campo) }}</span>
              <div class="lista-acoes" @click.stop>
                <button type="button" class="btn-acao" @click="abrirEditor(idx)" title="Editar">
                  <fa-icon icon="pencil-alt" />
                </button>
                <button type="button" class="btn-acao btn-acao--danger" @click="onRemoveCampo(idx)" title="Remover">
                  <fa-icon icon="trash-alt" />
                </button>
              </div>
            </div>

            <button type="button" class="btn-add-mapeamento" @click="abrirSeletor">
              <fa-icon icon="plus" /> Adicionar mapeamento
            </button>
          </template>

          <!-- VISTA: SELETOR DE TIPO -->
          <TipoRegraSelector
            v-else-if="vista === 'tipo'"
            @voltar="voltarLista"
            @selecionar="criarComTipo"
          />

          <!-- VISTA: EDITOR DE REGRA -->
          <template v-else-if="vista === 'editor' && campoEditandoRef">
            <div class="editor-header">
              <button type="button" class="btn-voltar" @click="voltarLista">
                <fa-icon icon="arrow-left" /> Voltar para a lista
              </button>
              <div class="editor-titulo">
                {{ campoEditandoRef.regra ? badgeLabel(campoEditandoRef) : 'Campo simples' }}
              </div>
            </div>

            <!-- Modo simples -->
            <div v-if="!campoEditandoRef.regra" class="editor-secao">
              <div class="secao-titulo">Origem</div>
              <div class="row form-group">
                <div class="col-md-12">
                  <label class="field-label">{{ campoDe(campoEditandoRef.de) }}</label>
                  <input
                      class="form-control form-control-sm"
                      :class="{ 'is-invalid': !campoEditandoRef.de || campoEditandoRef.de.trim().length === 0 }"
                      type="text"
                      v-model="campoEditandoRef.de"
                  />
                  <button v-if="possuiCamposDe" class="btn-selecionar" @click="openModalCamposDisponiveisDe(campoEditandoRef)">
                    Selecionar da lista
                  </button>
                </div>
              </div>
            </div>

            <!-- Modo regra -->
            <div v-else class="editor-secao">
              <RegraCampoEditor
                  :value="campoEditandoRef.regra"
                  :campos="camposParaRegra"
                  :operadores="operadores"
                  :modo-troca-tipo="false"
                  @input="atualizarRegra(campoEditandoRef, $event)"
              />
            </div>

            <div class="editor-secao">
              <div class="secao-titulo">Destino no ERP</div>
              <div class="row form-group">
                <div class="col-md-12">
                  <label class="field-label">{{ campoPara(campoEditandoRef.para) }}</label>
                  <input
                      class="form-control form-control-sm"
                      :class="{ 'is-invalid': !campoEditandoRef.para || campoEditandoRef.para.trim().length === 0 }"
                      type="text"
                      v-model="campoEditandoRef.para"
                  />
                  <button v-if="possuiCamposPara" class="btn-selecionar" @click="openModalCamposDisponiveisPara(campoEditandoRef)">
                    Selecionar da lista
                  </button>
                </div>
              </div>
            </div>

            <div class="editor-secao">
              <button type="button" class="secao-toggle" @click="opcoesAbertas = !opcoesAbertas">
                <fa-icon :icon="opcoesAbertas ? 'chevron-down' : 'chevron-right'" />
                Opções avançadas (formato, valor padrão, incluir se nulo)
              </button>
              <div v-if="opcoesAbertas" class="row form-group opcoes-row">
                <div class="col-md-3">
                  <label class="field-label">Valor padrão</label>
                  <input class="form-control form-control-sm" type="text" v-model="campoEditandoRef.valor_padrao" />
                </div>
                <div class="col-md-3">
                  <label class="field-label">Formato</label>
                  <select v-model="campoEditandoRef.conversao" class="form-control form-control-sm">
                    <option v-for="(value, label) in formatos" :key="label" :value="value">{{ label }}</option>
                  </select>
                </div>
                <div v-if="validaFormato(campoEditandoRef)" class="col-md-3">
                  <label class="field-label">Inverter sinal</label>
                  <select v-model="campoEditandoRef.inverte_sinal" class="form-control form-control-sm">
                    <option value="1">Sim</option>
                    <option value="0">Não</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="field-label">Incluir se nulo</label>
                  <select v-model="campoEditandoRef.incluir_se_nulo" class="form-control form-control-sm">
                    <option value="1">Sim</option>
                    <option value="0">Não</option>
                  </select>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div class="modal-footer-bar">
        <CButton variant="outline" color="secondary" @click="close">Cancelar</CButton>
        <div class="footer-spacer"></div>
        <CButton
          v-if="vista === 'editor'"
          color="primary"
          :disabled="!isCampoValido(campoEditandoRef || {})"
          @click="voltarLista"
        >
          OK
        </CButton>
        <CButton
          v-else-if="vista === 'lista'"
          color="primary"
          :disabled="!camposValidos"
          @click="handleSubmit"
        >
          Salvar todos
        </CButton>
      </div>
    </modal>
  </div>
</template>

<script>
import CloseModal from "../../../components/CloseModal";
import CamposDisponiveis from "./CamposDisponiveis";
import RegraCampoEditor, { novaRegra } from "./RegraCampoEditor";
import TipoRegraSelector from "./TipoRegraSelector";
import { isEmpty } from "lodash";

const campoMapeado = (tipo) => ({
  'de': '',
  'para': '',
  'conversao': null,
  'inverte_sinal': 0,
  'incluir_se_nulo': 1,
  'valor_padrao': '',
  'ordem': 1,
  'regra': null,
  tipo
});

const TIPO_BADGES = {
  simples:      { label: 'Simples',      icone: 'exchange-alt', cls: 'badge--simples' },
  condicional:  { label: 'Condicional',  icone: 'code-branch',  cls: 'badge--condicional' },
  mapeamento:   { label: 'Mapeamento',   icone: 'table',        cls: 'badge--mapeamento' },
  concatenacao: { label: 'Concatenação', icone: 'link',         cls: 'badge--concatenacao' },
  coalesce:     { label: '1º disponível',icone: 'list-ol',      cls: 'badge--coalesce' },
};

export default {
  name: "Edit",
  components: {
    CamposDisponiveis,
    CloseModal,
    RegraCampoEditor,
    TipoRegraSelector,
  },
  props: [
    'close',
    'tipo',
    'campos',
    'formatos',
    'operadores',
    'onSubmit',
  ],
  data() {
    return {
      vista: 'lista',
      indexEditando: null,
      campoEmEdicao: {},
      opcoesAbertas: false,
    };
  },
  watch: {
    'tipo.chave'() {
      // Sempre que mudar o tipo selecionado na tela principal, voltar para lista
      this.vista = 'lista';
      this.indexEditando = null;
      this.opcoesAbertas = false;
    },
  },
  computed: {
    campoEditandoRef() {
      if (this.indexEditando === null) return null;
      return this.campos[this.indexEditando];
    },
    camposValidos() {
      return this.campos.every((c) => this.isCampoValido(c));
    },
    possuiCamposDe() {
      return !isEmpty(this.tipo.de);
    },
    possuiCamposPara() {
      return !isEmpty(this.tipo.para);
    },
    camposParaRegra() {
      if (isEmpty(this.tipo.de)) return [];
      return Object.entries(this.tipo.de).map(([value, label]) => ({ value, label }));
    },
  },
  methods: {
    isCampoValido(campo) {
      if (!campo) return false;
      if (campo.regra) {
        return campo.para && campo.para.trim().length > 0;
      }
      return campo.de && campo.de.trim().length > 0
          && campo.para && campo.para.trim().length > 0;
    },
    validaFormato(campo) {
      return campo.conversao == 'int' || campo.conversao == 'float';
    },
    alterarCampoDe(novoValor) { this.campoEmEdicao.de = novoValor; },
    alterarCampoPara(novoValor) { this.campoEmEdicao.para = novoValor; },
    openModalCamposDisponiveisDe(campo) {
      this.campoEmEdicao = campo;
      this.$modal.show('camposDisponiveisDe');
    },
    openModalCamposDisponiveisPara(campo) {
      this.campoEmEdicao = campo;
      this.$modal.show('camposDisponiveisPara');
    },
    campoDe(nomeCampo) {
      return 'De: ' + (this.tipo.de && this.tipo.de[nomeCampo] ? this.tipo.de[nomeCampo] : 'Campo customizado');
    },
    campoPara(nomeCampo) {
      return 'Para: ' + (this.tipo.para && this.tipo.para[nomeCampo] ? this.tipo.para[nomeCampo] : 'Campo customizado');
    },
    badgeClass(campo) {
      const t = campo.regra ? campo.regra.tipo : 'simples';
      return (TIPO_BADGES[t] || TIPO_BADGES.simples).cls;
    },
    badgeIcone(campo) {
      const t = campo.regra ? campo.regra.tipo : 'simples';
      return (TIPO_BADGES[t] || TIPO_BADGES.simples).icone;
    },
    badgeLabel(campo) {
      const t = campo.regra ? campo.regra.tipo : 'simples';
      return (TIPO_BADGES[t] || TIPO_BADGES.simples).label;
    },
    resumoLinha(campo) {
      const para = campo.para || '?';
      if (!campo.regra) {
        const de = campo.de || '?';
        return `${de}  →  ${para}`;
      }
      switch (campo.regra.tipo) {
        case 'mapeamento': {
          const origem = campo.regra.campo || '?';
          const n = Object.keys(campo.regra.mapa || {}).length;
          return `${origem} (${n} tradução${n === 1 ? '' : 'ões'})  →  ${para}`;
        }
        case 'concatenacao': {
          const n = (campo.regra.partes || []).length;
          return `${n} parte${n === 1 ? '' : 's'} concatenada${n === 1 ? '' : 's'}  →  ${para}`;
        }
        case 'coalesce': {
          const n = (campo.regra.campos || []).length;
          return `${n} campo${n === 1 ? '' : 's'} (1º preenchido)  →  ${para}`;
        }
        case 'condicional': {
          const n = (campo.regra.casos || []).length;
          return `${n} regra${n === 1 ? '' : 's'} + fallback  →  ${para}`;
        }
        default:
          return `(regra)  →  ${para}`;
      }
    },
    abrirSeletor() {
      this.vista = 'tipo';
    },
    criarComTipo(tipoEscolhido) {
      const novo = campoMapeado(this.tipo.chave);
      if (tipoEscolhido !== 'simples') {
        novo.regra = novaRegra(tipoEscolhido);
      }
      this.campos.push(novo);
      this.indexEditando = this.campos.length - 1;
      this.vista = 'editor';
      this.opcoesAbertas = false;
    },
    abrirEditor(idx) {
      this.indexEditando = idx;
      this.vista = 'editor';
      this.opcoesAbertas = false;
    },
    voltarLista() {
      // Se voltou de um editor que não é válido, descarta o registro recém-criado vazio
      if (this.vista === 'editor' && this.indexEditando !== null) {
        const campo = this.campos[this.indexEditando];
        if (campo && !this.isCampoValido(campo) && !campo.de && !campo.para && !campo.regra) {
          this.campos.splice(this.indexEditando, 1);
        }
      }
      this.indexEditando = null;
      this.vista = 'lista';
    },
    atualizarRegra(campo, regra) {
      this.$set(campo, 'regra', regra);
      this.$set(campo, 'de', '');
    },
    onRemoveCampo(index) {
      this.campos.splice(index, 1);
    },
    handleSubmit() {
      this.onSubmit(this.campos, this.tipo.chave);
    },
  },
};
</script>

<style scoped>
.modal-header-info {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e9ecef;
}
.header-title {
  font-size: 16px;
  font-weight: 600;
  color: #3a3e81;
}
.header-desc {
  font-size: 12px;
  color: #667085;
  margin-top: 4px;
}
.header-desc code {
  font-size: 11px;
  color: #344054;
  background: #f2f4f7;
  padding: 1px 5px;
  border-radius: 3px;
}

/* Empty state */
.empty-state { text-align: center; padding: 40px 20px; }
.empty-icon {
  width: 56px; height: 56px; border-radius: 14px;
  background: #f2f2f8; color: #3a3e81;
  font-size: 22px;
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 12px;
}
.empty-text { font-weight: 600; font-size: 15px; color: #1d2939; }
.empty-desc { font-size: 13px; color: #667085; margin-top: 4px; }

/* Lista de cards */
.lista-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  margin-bottom: 6px;
  border: 1px solid #e4e7eb;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition: all 0.15s;
}
.lista-card:hover {
  border-color: #3a3e81;
  background: #fafbff;
}
.lista-card--invalid {
  border-color: #fda29b;
  background: #fef3f2;
}
.lista-ordem {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  background: #f2f4f7;
  padding: 2px 7px;
  border-radius: 4px;
  flex-shrink: 0;
}
.lista-tipo-badge {
  font-size: 11px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 12px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.badge--simples      { background: #eef2ff; color: #4338ca; }
.badge--condicional  { background: #fef3c7; color: #b45309; }
.badge--mapeamento   { background: #dcfce7; color: #15803d; }
.badge--concatenacao { background: #e0f2fe; color: #0369a1; }
.badge--coalesce     { background: #fce7f3; color: #be185d; }
.lista-resumo {
  flex: 1;
  font-size: 13px;
  color: #344054;
  font-family: 'Menlo', 'Consolas', monospace;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.lista-acoes {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}
.btn-acao {
  background: none;
  border: none;
  color: #98a2b3;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
}
.btn-acao:hover { color: #3a3e81; background: #f2f2f8; }
.btn-acao--danger:hover { color: #d92d20; background: #fef3f2; }

.btn-add-mapeamento {
  width: 100%;
  background: #fff;
  border: 1px dashed #3a3e81;
  color: #3a3e81;
  font-size: 13px;
  font-weight: 500;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 8px;
  transition: all 0.15s;
}
.btn-add-mapeamento:hover { background: #f2f2f8; }

/* Editor */
.editor-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e9ecef;
}
.btn-voltar {
  background: none;
  border: none;
  color: #3a3e81;
  font-size: 13px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
}
.btn-voltar:hover { background: #f2f2f8; }
.editor-titulo {
  font-size: 15px;
  font-weight: 600;
  color: #1d2939;
}
.editor-secao {
  margin-bottom: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid #f2f4f7;
}
.editor-secao:last-child {
  border-bottom: none;
  padding-bottom: 0;
}
.secao-titulo {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 8px;
}
.secao-toggle {
  background: none;
  border: none;
  color: #3a3e81;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 0;
  display: flex;
  align-items: center;
  gap: 6px;
}
.secao-toggle:hover { text-decoration: underline; }
.opcoes-row { margin-top: 10px; }

.field-label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
}
.btn-selecionar {
  background: none;
  border: 1px solid #dddce9;
  color: #3a3e81;
  font-size: 11px;
  font-weight: 500;
  padding: 3px 8px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 4px;
}
.btn-selecionar:hover { background: #f2f2f8; }

/* Modal footer */
.modal-footer-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e9ecef;
}
.footer-spacer { flex: 1; }
</style>
